import React from "react";
import PropTypes from "prop-types";
import { Container } from "react-bootstrap";

import "./DiferenciaisCurso.css";

const TITULO_OCULTO = "um olhar para o mundo";

const normalizarTitulo = (valor = "") =>
	String(valor)
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.trim()
		.toLowerCase();

const deveOcultar = (titulo) =>
	normalizarTitulo(titulo) === TITULO_OCULTO;

export default function DiferenciaisCurso({
	nomeCurso,
	categorias = [],
	habilidades = [],
}) {
	const listaCategorias = Array.isArray(categorias) ? categorias : [];
	const listaHabilidades = Array.isArray(habilidades) ? habilidades : [];

	const categoriasFiltradas = listaCategorias.filter(
		(categoria) =>
			!deveOcultar(categoria?.cursoPerfilDoEgressoCategoriaNome)
	);

	const habilidadesFiltradas = listaHabilidades.filter(
		(habilidade) =>
			!deveOcultar(habilidade?.cursoPerfilDoEgressoHabilidadeNome)
	);

	const nomeCursoSeguro = nomeCurso || "este curso";

	if (categoriasFiltradas.length === 0) {
		return (
			<Container>
				<div className="diferenciaisCurso-barraVazia" aria-hidden="true" />
			</Container>
		);
	}

	return (
		<section className="diferenciaisCurso">
			<Container>
				<div className="diferenciaisCurso-intro">
					<span className="diferenciaisCurso-eyebrow">Por que escolher</span>
					<h2>{nomeCursoSeguro}?</h2>
				</div>

				<div className="diferenciaisCurso-grid">
					{categoriasFiltradas.map((categoria, index) => {
						const habilidadesDaCategoria = habilidadesFiltradas.filter(
							(habilidade) =>
								habilidade?.cursoPerfilDoEgressoCategoriaId ==
								categoria?.cursoPerfilDoEgressoCategoriaId
						);

						return (
							<article
								className="diferenciaisCurso-card"
								key={`${
									categoria?.cursoPerfilDoEgressoCategoriaId ||
									categoria?.cursoPerfilDoEgressoCategoriaNome ||
									"categoria"
								}-${index}`}
							>
								<h3>{categoria?.cursoPerfilDoEgressoCategoriaNome}</h3>

								{habilidadesDaCategoria.length > 0 && (
									<div className="diferenciaisCurso-itens">
										{habilidadesDaCategoria.map(
											(habilidade, habilidadeIndex) => (
												<div
													className="diferenciaisCurso-item"
													key={`${
														habilidade?.cursoPerfilDoEgressoHabilidadeNome ||
														"habilidade"
													}-${habilidadeIndex}`}
												>
													<span className="diferenciaisCurso-marcador" />

													<div className="diferenciaisCurso-itemConteudo">
														{habilidade?.cursoPerfilDoEgressoHabilidadeNome && (
															<strong>
																{
																	habilidade.cursoPerfilDoEgressoHabilidadeNome
																}
															</strong>
														)}

														{habilidade?.cursoPerfilDoEgressoHabilidadeDescricao && (
															<p>
																{
																	habilidade
																		.cursoPerfilDoEgressoHabilidadeDescricao
																}
															</p>
														)}
													</div>
												</div>
											)
										)}
									</div>
								)}
							</article>
						);
					})}
				</div>
			</Container>
		</section>
	);
}

DiferenciaisCurso.propTypes = {
	nomeCurso: PropTypes.string.isRequired,
	categorias: PropTypes.array,
	habilidades: PropTypes.array,
};
